'use client';

import { use } from 'react';

import { FunnelTrackingContext } from './funnel-tracking.context';

export function useIsFunnelTracked(): boolean {
  return use(FunnelTrackingContext);
}
